<template>
    <Header></Header>

    <div class="main-height">
      <section class="change-password">
        <div class="container">
          <div class="inner-container">
            <div class="row card bg-light border-0 rounded-4 p-sm-5 p-4 pt-6">
              <div class="col-12 success-state-reserve">
                <div v-if="!success.length">
                  <h3 class="fw-bold mb-2">Link your device</h3>
                  <p class="text-secondary mb-2">
                    Enter the activation code shown on your device.
                  </p>

                  <!-- CODE INPUT -->
                  <div class="input-group device-code-input">
                    <img src="../assets/lock2.svg" alt="icon" height="20" class="mx-2">
                    <input type="text" class="form-control py-3 rounded" placeholder="1234-5678" v-model="userCode"
                           @input="normalizeCode" :disabled="success.length > 0 || isTrialUser" @keyup.enter="doApprove" autocomplete="off"/>
                  </div>

                  <!-- ERROR -->
                  <div v-if="error.length" class="alert-danger mt-3 text-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         class="bi bi-exclamation-circle me-1 mb-1" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                    </svg>
                    {{ error }}
                  </div>

                  <button v-if="!success.length" class="btn btn-primary btn-main w-100 mt-3 rounded-0"
                          @click="doApprove" id="btn" :disabled="isTrialUser">
                    <span v-show="!loading">Link device</span>
                    <span v-show="loading" class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;"
                          role="status" aria-hidden="true"></span>
                    <span v-show="loading" class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;"
                          role="status" aria-hidden="true"></span>
                    <span v-show="loading" class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;"
                          role="status" aria-hidden="true"></span>
                  </button>
                </div>

                <div v-else class="success-state-reserve text-success fw-bold d-flex flex-column align-items-center justify-content-center text-center">
                <img src="../assets/green-tick.png" alt="Green tick" class="mb-2" style="max-width:64px; height:auto;" />
                  {{ success }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer></Footer>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DeviceAuthService from "@/services/device-auth-service";

export default defineComponent({
  name: "Device Login",
  components: { Header, Footer },
  data() {
    return {
      userCode: "",
      error: "",
      success: "",
      loading: false,
      userPlan: null,
    };
  },
  computed: {
    isTrialUser() {
      return this.userPlan?.trial === true;
    },
  },
  methods: {
    doAccount() {
      this.$router.push("/account");
    },
    goEvents () {
      this.$router.push('/events')
    },
    normalizeCode() {
      // Keep only digits + dash, auto format ####-####
      let v = (this.userCode || "").toString().toUpperCase();

      // remove spaces
      v = v.replace(/\s+/g, "");

      // keep digits only
      const digits = v.replace(/[^0-9]/g, "").slice(0, 8);

      if (digits.length <= 4) {
        this.userCode = digits;
      } else {
        this.userCode = `${digits.slice(0, 4)}-${digits.slice(4)}`;
      }
    },

    async doApprove() {
      if (this.loading) return;

      if (this.isTrialUser) {
        this.error = "Linking a device is available only for premium subscribers.";
        return;
      }

      this.error = "";
      this.success = "";

      const code = (this.userCode || "").trim();

      if (!/^\d{4}-\d{4}$/.test(code)) {
        this.error = "Please enter a valid code in format 1234-5678.";
        return;
      }

      this.loading = true;
      try {
        // call BE approve
        // adjust payload / method to match your API
        const ok = await DeviceAuthService.approve(code);

        if (ok === true) {
          this.success = "Device approved. Go back to your device.";
        } else {
          this.error = "Invalid or expired code. Please try again.";
        }
      } catch (e) {
        this.error = "Could not approve device. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))

    if (this.isTrialUser) {
      this.error = "Linking a device is available only for premium subscribers.";
      return;
    }

    // Auto-fill from URL: /device?user_code=1234-5678
    const code = this.$route.query.user_code;

    if (typeof code === "string" && code.length) {
      this.userCode = code;
      this.normalizeCode();

      // Auto-approve if code was provided
      // (only works if the user is already logged in)
      this.doApprove();
    }
  },
});
</script>

<style>
@import "../assets/style.css";
</style>
